import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { pdfjs } from "react-pdf";
import * as Sentry from "@sentry/react";

pdfjs.GlobalWorkerOptions.workerSrc =
  window.location.origin + "/pdf.worker.min.mjs";

Sentry.init({
  dsn: "https://a1ff2aeec0de15a700036546cad367e0@o4509166360592384.ingest.us.sentry.io/4511228464201728",
  sendDefaultPii: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
